import { useEffect, useState } from 'react';
import { NSBanner, NSColumn, NSRow, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentRoutes } from '../PaymentRoutes';
import { EncodingOperation } from 'namirasoft-core';

export interface PaymentSuccessfulPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface PaymentSuccessfulPageState
{
	counter: number;
}

function PaymentSuccessfulPage(props: PaymentSuccessfulPageProps)
{
	let [state, setState] = useState<PaymentSuccessfulPageState>({
		counter: 10
	});

	useEffect(() =>
	{
		function loop()
		{
			setState(prev => ({ ...prev, counter: state.counter-- }));
			if (state.counter === 0)
			{
				let callback = props.url.getQuery("callback");
				if (callback)
					try
					{
						callback = EncodingOperation.Base64Decode(callback);
					} catch (error)
					{
						callback = "";
					}
				if (!callback)
					callback = PaymentRoutes.PaymentList(false, "");
				window.location.href = callback;
			}
			else
				setTimeout(loop, 1000);
		}
		loop();
		// eslint-disable-next-line
	}, []);

	return (
		<PaymentLayout {...props}
			action={{
				title: "Payment Successful", description: "See the details of our offer and take your next action."
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/payment-successful.png",
								alt: "payment successful bot"
							}}
							imageRight={null}
							title={{
								text: "Thank you!",
								style: { color: "green" }
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<p>
					We are pleased to confirm that your operation has been successfully completed.
					<NSSpace size={NSSpaceSizeType.NANO} />
					It might take some time for the operation to take effect in our system.
					<NSSpace size={NSSpaceSizeType.NANO} />
					Thank you for choosing Namirasoft.
				</p>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<h4 style={{ color: "green" }}>
					You will be redirected to where you came from in {`${state.counter}`} second(s).
				</h4>
			</NSSection>
		</ PaymentLayout >
	);
}

export default PaymentSuccessfulPage;